export default {
  title: "Overview of operations",
  buttonText: "Operations"
};
